import { User } from "@/data/interfaces/User";
import { splitFullName } from "@/utils/splitFullName";

type NameFields = Pick<User, "name" | "surname">;

/**
 * Backend sometimes returns `surname: null` while `name` holds the full name
 * (e.g. matches `orders.full_name`). Split for forms and completion checks.
 */
export function getProfileNameParts(user: NameFields): {
  firstName: string;
  surname: string;
} {
  const trimmedSurname = (user?.surname ?? "").trim();
  if (trimmedSurname) {
    return {
      firstName: (user?.name ?? "").trim(),
      surname: trimmedSurname,
    };
  }
  const { name, surname } = splitFullName(user?.name ?? "");
  return { firstName: name, surname };
}

/** Display full name without stringifying null/undefined (e.g. checkout prefill). */
export function formatUserFullNameForDisplay(user: NameFields): string {
  const { firstName, surname } = getProfileNameParts(user);
  return [firstName, surname].filter((p) => p.trim()).join(" ");
}

export const isUserInfoFilled = (user: User): boolean => {
  if (!user?.phone?.trim()) return false;
  const { surname } = getProfileNameParts(user);
  return !!surname.trim();
};
